import { useEffect, useState } from 'react';
import Header from '../inc/Header'
import Navigation from '../inc/Navigation'
import { isEnableModify, listLanguage } from '../../request/Request';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import LoadingPage from '../inc/LoadingPage';
import { softDeleteNewsletter } from "../../../project/services/NewsletterService";
import { useEnvoiAbonnes } from '../../hooks/useEnvoiAbonnes';
import { NEWSLETTER_ENVOI_API } from '../../request/NewsletterRequest';
import EnvoiAbonnesModal from '../inc/EnvoiAbonnesModal';
import { useNewslettersPagines } from '../../hooks/useNewslettersPagines';

const FILTRES_VIDES = { titre: '', date: '', idlanguage: '' };

const ENVOI_MODAL_ID = 'confirmationEnvoiListeNewsletter';

function StatutNewsletter({ newsletter }) {
    if (newsletter.send) return <span className="wf-badge wf-badge-envoye"><i className="bi bi-send"></i>Envoyé</span>;
    if (newsletter.verified) return <span className="wf-badge wf-badge-verifie"><i className="bi bi-check-circle"></i>Vérifié</span>;
    return <span className="wf-badge wf-badge-brouillon"><i className="bi bi-file-text"></i>Brouillon</span>;
}

function codeLangue(newsletter) { return newsletter.language?.code?.toUpperCase(); }

function formatDate(dateStr) {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.slice(0, 10).split('-');
    return `${day}/${month}/${year}`;
}

function ListNewsletter() {
    const [languages, setLanguages] = useState([]);
    // filtres garde la même référence tant qu'on ne valide pas le formulaire : pas de rechargement inutile.
    const [filtres, setFiltres] = useState(FILTRES_VIDES);
    const [isGroupe, setIsGroupe] = useState(true);
    const [page, setPage] = useState(1);
    let navigate = useNavigate();
    const [selectedId, setSelectedId] = useState(null);
    const envoi = useEnvoiAbonnes(NEWSLETTER_ENVOI_API);

    const openSendModal = (id) => {
        setSelectedId(id);
        envoi.openEnvoi(id);
    };
    const modifyUrl = (id) => process.env.REACT_APP_ADMIN_URL + '/update-NewsLetter/' + id;
    const navigateToModify = (id) => navigate(modifyUrl(id));
    const ficheUrl = (id) => process.env.REACT_APP_ADMIN_URL + '/fiche-NewsLetter/' + id;
    const navigateToFiche = (id) => navigate(ficheUrl(id));

    const handleSoftDelete = async (id) => {
        try {
            const isDeleted = await softDeleteNewsletter(id);
            if (isDeleted) window.location.reload();
        } catch (err) {
            alert("Erreur lors de la suppression de la newsletter.");
        }
    };

    const liste = useNewslettersPagines(filtres, isGroupe, page);

    useEffect(() => {
        listLanguage().then((reponse) => {
            if (reponse?.status === 200) setLanguages(reponse.data);
        });
    }, []);

    const appliquerFiltres = (e) => {
        e.preventDefault();
        const form = new FormData(e.target);
        // En mode groupé, le filtre Langue met la version de cette langue en tête de ligne.
        setFiltres({ titre: form.get('titre'), date: form.get('date'), idlanguage: form.get('idlanguage') });
        setPage(1);
    };

    // Version présente : puce vers sa modification ; sinon puce « manquante » (pas de traduction automatique pour les NL).
    function puceLangue(ligne, langue) {
        const code = langue.code?.toUpperCase();
        const version = ligne.versions.find(n => String(n.language?.idlanguage) === String(langue.idlanguage));
        if (!version) return <span key={code} className="lang-chip lang-manquante" title={`Version ${code} manquante`}>{code}</span>;
        // Non groupé : la langue de la ligne est pleine, l'autre version reste en contour.
        const classe = !isGroupe && version === ligne.principal ? 'lang-courante' : 'lang-traduction';
        return <Link key={code} className={`lang-chip ${classe}`} to={modifyUrl(version.id_newsletter)} title={`Ouvrir la version ${code}`}>{code}</Link>;
    }

    // Un seul badge quand les versions sont au même stade ; sinon un badge par langue pour voir laquelle est en retard.
    function statutsLigne(ligne) {
        const versions = isGroupe ? ligne.versions : [ligne.principal];
        const etape = (n) => `${n.verified}-${n.send}`;
        if (versions.every(n => etape(n) === etape(versions[0]))) return <StatutNewsletter newsletter={versions[0]} />;
        return <div className="d-flex flex-column gap-1">{versions.map(n => (
            <span key={n.id_newsletter} className="d-flex align-items-center gap-1"><small className="text-muted">{codeLangue(n)}</small><StatutNewsletter newsletter={n} /></span>
        ))}</div>;
    }

    // Boutons sur la version principale ; l'autre version se gère depuis sa puce de langue (sa page de modification).
    function actionsVersion(newsletter) {
        const id = newsletter.id_newsletter;
        return (
            <>
                <div className="d-flex align-items-center gap-1">
                    <span className="action-btn-tip action-btn-tip-marine" data-label="Modifier">
                        <button type="button" className="btn-axian-marine" aria-label="Modifier" onClick={() => navigateToModify(id)}><i className="bx bxs-edit-alt"></i></button>
                    </span>
                    {!newsletter.verified && !newsletter.send && (
                        <span className="action-btn-tip action-btn-tip-vert" data-label="Vérifier">
                            <button type="button" className="btn-axian-vert" aria-label="Vérifier" onClick={() => navigateToFiche(id)}><i className="bi bi-check-circle"></i></button>
                        </span>
                    )}
                    {newsletter.verified && !newsletter.send && (
                        <span className="action-btn-tip action-btn-tip-bleu-clair" data-label="Envoyer">
                            <button type="button" className="btn-axian-bleu-clair" aria-label="Envoyer" data-bs-toggle="modal" data-bs-target={'#' + ENVOI_MODAL_ID} onClick={() => openSendModal(id)}><i className="bi bi-send btn-icon-sm"></i></button>
                        </span>
                    )}
                    <span className="action-btn-tip action-btn-tip-cramoisie-dark" data-label="Supprimer">
                        <button type="button" className="btn-axian-cramoisie-dark" aria-label="Supprimer" data-bs-toggle="modal" data-bs-target={"#verticalycentered" + id}><i className="bx bxs-trash-alt"></i></button>
                    </span>
                </div>
                {modalSuppression(id)}
            </>
        );
    }

    function modalSuppression(id) {
        return (
            <div className="modal fade" id={"verticalycentered" + id} tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Attention</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            Êtes-vous sûr de vouloir supprimer cette newsletter ?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
                            <button type="button" className="btn-axian-cramoisie-light" data-bs-dismiss="modal" onClick={() => handleSoftDelete(id)}>Supprimer</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    function ligneTableau(ligne) {
        const { principal } = ligne;
        return (
            <tr key={principal.id_newsletter} className="table-row-clickable" onClick={() => navigateToFiche(principal.id_newsletter)}>
                <td>
                    <div className="list-title-cell" title={ligne.versions.map(n => n.titre).join('\n')}>
                        N° {principal.numero} — {principal.titre}
                    </div>
                </td>
                <td className="table-date">{formatDate(principal.date_sortie)}</td>
                <td onClick={(e) => e.stopPropagation()}><div className="d-flex gap-1">{languages.map(l => puceLangue(ligne, l))}</div></td>
                <td>{statutsLigne(ligne)}</td>
                <td className={isEnableModify() ? 'action' : 'action-solo'} onClick={(e) => e.stopPropagation()}>{isEnableModify() && actionsVersion(principal)}</td>
            </tr>
        );
    }

    // Même rendu que la pagination des communiqués : 2 pages de part et d'autre de la page courante.
    function paginationNav({ currentPage: pageCourante, totalPages }) {
        if (totalPages <= 1) return null;
        const pages = [];
        for (let i = Math.max(1, pageCourante - 2); i <= Math.min(totalPages, pageCourante + 2); i++) pages.push(i);
        return (
            <nav aria-label="Pagination des newsletters">
                <ul className="pagination justify-content-end">
                    <li className={'page-item' + (pageCourante === 1 ? ' disabled' : '')}>
                        <button type="button" className="page-link" onClick={() => setPage(pageCourante - 1)} disabled={pageCourante === 1}>Précédent</button>
                    </li>
                    {pages.map(i => (
                        <li key={i} className={'page-item' + (i === pageCourante ? ' active' : '')}>
                            <button type="button" className="page-link" onClick={() => setPage(i)} aria-current={i === pageCourante ? 'page' : undefined}>{i}</button>
                        </li>
                    ))}
                    <li className={'page-item' + (pageCourante === totalPages ? ' disabled' : '')}>
                        <button type="button" className="page-link" onClick={() => setPage(pageCourante + 1)} disabled={pageCourante === totalPages}>Suivant</button>
                    </li>
                </ul>
            </nav>
        );
    }

    if (liste.loadError) return <p>Erreur: {liste.loadError.message}</p>;
    if (!liste.info) return <LoadingPage/>;

    return (
        <><Header /><Navigation /><ToastContainer /><main id="main" className="main">
            <div className="pagetitle">
                <h1>Newsletters</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to={process.env.REACT_APP_ADMIN_URL + "/dashboard"}>Accueil</Link></li>
                        <li className="breadcrumb-item"><Link to={process.env.REACT_APP_ADMIN_URL + "/list-Newsletter"}>Newsletters</Link></li>
                        <li className="breadcrumb-item active">Liste</li>
                    </ol>
                </nav>
            </div>
            <section className="section">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                <h2 className="card-title">Filtre</h2>
                                <form className="row g-3 formulaire" onSubmit={appliquerFiltres}>
                                    <div className="col-md-4">
                                        <label htmlFor="titre" className="form-label">Titre</label>
                                        <input type="text" className="form-control" id="titre" name="titre" />
                                    </div>
                                    <div className="col-md-2">
                                        <label htmlFor="idlanguage" className="form-label">Langue</label>
                                        <select className="form-select" id="idlanguage" name="idlanguage" defaultValue="">
                                            <option value="">Toutes</option>
                                            {languages.map(l => <option key={l.idlanguage} value={l.idlanguage}>{l.code?.toUpperCase()}</option>)}
                                        </select>
                                    </div>
                                    <div className="col-md-3">
                                        <label htmlFor="date" className="form-label">Date</label>
                                        <input type="date" className="form-control" id="date" name="date" />
                                    </div>
                                    <div className="col-md-3">
                                        <div className="text-center">
                                            <label className="form-label">#</label>
                                            <button type="submit" className="btn-axian-cramoisie-dark btn-full">Filtrer</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                <h2 className="card-title">Liste des newsletters</h2>
                                <div className="d-flex align-items-center gap-3 mb-3">
                                    {isEnableModify() && <Link to={process.env.REACT_APP_ADMIN_URL + "/add-Newsletter"}>
                                        <button type="button" className="btn-axian-charbon">
                                            <i className="bi bi-plus"></i>Nouveau
                                        </button>
                                    </Link>}
                                    <div className="form-check form-switch mb-0 ms-auto">
                                        <input className="form-check-input switch-bleu-clair" type="checkbox" role="switch" id="grouperVersions" checked={isGroupe}
                                            onChange={(e) => { setIsGroupe(e.target.checked); setPage(1); }} />
                                        <label className="form-check-label" htmlFor="grouperVersions">Grouper EN / FR</label>
                                    </div>
                                </div>
                                <div className="table-responsive mt-1">
                                    <table className="table table-striped table-axian">
                                        <thead>
                                            <tr>
                                                <th scope="col">Titre</th>
                                                <th scope="col">Date</th>
                                                <th scope="col">Langues</th>
                                                <th scope="col">Statut</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        {/* Les anciennes lignes restent affichées (estompées) pendant le rechargement : pas de saut de hauteur. */}
                                        <tbody className={liste.isChargement ? 'liste-en-chargement' : undefined} aria-busy={liste.isChargement}>
                                            {liste.lignes.map(ligneTableau)}
                                        </tbody>
                                    </table>
                                </div>
                                {paginationNav(liste.info)}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        <EnvoiAbonnesModal modalId={ENVOI_MODAL_ID} id={selectedId} envoi={envoi} onSent={liste.recharger}
            envoiLabel="Cette newsletter sera envoyée à" />
        </>
    );
}

export default ListNewsletter;
